import { render, staticRenderFns } from "./followUpCell.vue?vue&type=template&id=7731cc32&scoped=true"
import script from "./followUpCell.vue?vue&type=script&lang=js"
export * from "./followUpCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7731cc32",
  null
  
)

export default component.exports